(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.bodyReveal = document.querySelector('body');
      this.facetsContainer = document.getElementById('facet-main-container');
      this.filterContainer = document.getElementById('facets-container');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.bodyReveal.classList.remove('show-sticky-header')
      this.closeMenuDisclosure();
      //this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if(this.filterContainer && this.facetsContainer){
        
        let position = this.filterContainer.getBoundingClientRect()
        let facetsPosition = this.facetsContainer.getBoundingClientRect()
        if(position.top === 0 && this.filterContainer.classList.contains('active')) this.bodyReveal.classList.add('show-sticky-header')
        if(position.top > 70 && this.filterContainer.classList.contains('active')) this.bodyReveal.classList.remove('show-sticky-header')
      }
      
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.bodyReveal.classList.remove('show-sticky-header')
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-search"]) return;
  try {
    
  let facetClear = document.getElementById('facetClear');
  let filterButton = document.getElementsByClassName('show-facets');
  let gridImages = document.getElementsByClassName('grid__item');
  let facetItem = document.getElementsByClassName('facets__item__count');
  let facetTotal = document.getElementsByClassName('facet-count');
  let buttonGridImage = document.getElementById('buttonGridImage');
  let buttonGrid = document.getElementById('buttonGrid');
  let productGrid = document.getElementsByClassName('product-grid');
  let filterContainer = document.getElementById('facets-container');
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  let isFilter = urlParams.get('sort_by');

  facetClear.addEventListener('click', (event) => {
    document.getElementById('facet-clear').innerHTML = 0;
    document.getElementById('facet-clear-mobile').innerHTML = '(0)';
  });

  for (var i = 0; i < filterButton.length; i++) {
    filterButton[i].addEventListener('click', (event) => {
      filterContainer.classList.toggle('active');
    });
  }

  for (var j = 0; j < facetItem.length; j++) {
    facetItem[j].addEventListener('click', (event) => {
      for (var k = 0; k < facetTotal.length; k++) {
        console.log(facetTotal[k].innerHTML);
      }
    });
  }

  buttonGrid.addEventListener('click', (event) => {
    if (buttonGrid.classList.contains('active')) {
      buttonGrid.classList.remove('active');
      for (var x = 0; x < productGrid.length; x++) {
        productGrid[x].classList.remove('grid--2-col-tablet-down');
        productGrid[x].classList.add('grid--1-col-tablet-down');
      }
    } else {
      buttonGrid.classList.add('active');
      for (var x = 0; x < productGrid.length; x++) {
        productGrid[x].classList.remove('grid--1-col-tablet-down');
        productGrid[x].classList.add('grid--2-col-tablet-down');
      }
    }
  });

  buttonGridImage.addEventListener('click', (event) => {
    if (buttonGridImage.classList.contains('active')) {
      buttonGridImage.classList.remove('active');
      for (var x = 0; x < gridImages.length; x++) {
        if (gridImages[x].classList.contains('primary__image')) {
          gridImages[x].classList.remove('hidden');
        }

        if (gridImages[x].classList.contains('secondary__image')) {
          gridImages[x].classList.add('hidden');
        }
      }
    } else {
      buttonGridImage.classList.add('active');
      for (var x = 0; x < gridImages.length; x++) {
        if (gridImages[x].classList.contains('primary__image')) {
          gridImages[x].classList.add('hidden');
        }

        if (gridImages[x].classList.contains('secondary__image')) {
          gridImages[x].classList.remove('hidden');
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
